import { render, staticRenderFns } from "./cart.vue?vue&type=template&id=3fce0bf2&scoped=true"
import script from "./cart.vue?vue&type=script&lang=js"
export * from "./cart.vue?vue&type=script&lang=js"
import style0 from "./cart.vue?vue&type=style&index=0&id=3fce0bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fce0bf2",
  null
  
)

export default component.exports